import PocketBase from 'pocketbase';
import Cookies from 'js-cookie';

// Ensure we have the PocketBase URL from environment variables
const POCKETBASE_URL = import.meta.env.VITE_PB_URL;
if (!POCKETBASE_URL) {
  throw new Error('VITE_PB_URL environment variable is required');
}

console.log('Connecting to PocketBase at:', POCKETBASE_URL);
const pb = new PocketBase(POCKETBASE_URL);

// Disable auto-cancellation to prevent request conflicts
pb.autoCancellation(false);

// Restore auth state from cookies
const authCookie = Cookies.get('pb_auth');
if (authCookie) {
  try {
    const authData = JSON.parse(authCookie);
    pb.authStore.save(authData.token, authData.model);
    console.log('Restored auth state from cookies');
  } catch (error) {
    console.error('Failed to restore auth state:', error);
    Cookies.remove('pb_auth');
  }
}

// Save auth state to cookies when it changes
pb.authStore.onChange((token, model) => {
  if (token && model) {
    Cookies.set('pb_auth', JSON.stringify({ token, model }), {
      expires: 7, // 7 days
      secure: window.location.protocol === 'https:',
      sameSite: 'strict'
    });
    console.log('Auth state saved to cookies');
  } else {
    Cookies.remove('pb_auth');
    console.log('Auth state cleared from cookies');
  }
});

// Helper functions
export const login = async (email, password) => {
  try {
    console.log('Attempting login for:', email);
    const authData = await pb.collection('users').authWithPassword(email, password);
    console.log('Login successful');
    return authData;
  } catch (error) {
    console.error('Login failed:', error);
    throw new Error(error.response?.message || error.message || 'Login failed');
  }
};

export const register = async (email, password, passwordConfirm, name) => {
  try {
    console.log('Attempting registration for:', email);
    const userData = {
      email,
      password,
      passwordConfirm,
      name: name || email.split('@')[0]
    };

    const user = await pb.collection('users').create(userData);
    console.log('User created successfully');

    // Auto-login after registration
    const authData = await pb.collection('users').authWithPassword(email, password);
    console.log('Auto-login after registration successful');
    return authData;
  } catch (error) {
    console.error('Registration failed:', error);
    throw new Error(error.response?.message || error.message || 'Registration failed');
  }
};

export const logout = () => {
  pb.authStore.clear();
  console.log('User logged out');
};

export const currentUser = () => {
  return pb.authStore.model;
};

export const isAuthenticated = () => {
  return pb.authStore.isValid;
};

// Test connection function
export const testConnection = async () => {
  try {
    const health = await pb.health.check();
    console.log('PocketBase connection test successful:', health);
    return true;
  } catch (error) {
    console.error('PocketBase connection test failed:', error);
    return false;
  }
};

export default pb;